import React, { useState } from "react";
import styled from "styled-components";

/**
 * @component Dropdown
 * @description 교시+쉬는시간 선택용 드롭다운 컴포넌트
 */

const List = styled.div`
  position: absolute;
  width: 320px;
  top: calc(100% + 0px);
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: white;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 21px 16px;
  z-index: 1000;
  align-items: center;
`;

const OptionGroup = styled.div`
  height: 200px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Option = styled.div`
  padding: 8px 16px;
  width: 283px;
  border-radius: 8px;
  border: ${props => props.selected ? '2px solid #256EF4' : '1px solid #E0E4EB'};
  background: ${props => props.selected ? '#ECF2FE' : 'white'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: #ECF2FE;
  }
`;

const Label = styled.span`
  color: #323232;
  font-size: 17px;
  line-height: 24px;
`;

const Time = styled.span`
  color: #323232;
  font-size: 17px;
  line-height: 24px;
`;

export const OPTIONS = [
  { label: "아침 조례", time: "08:00-08:50" },
  { label: "1교시+쉬는 시간", time: "08:50-09:45" },
  { label: "2교시+쉬는 시간", time: "09:45-10:40" },
  { label: "3교시+쉬는 시간", time: "10:40-11:35" },
  { label: "4교시+쉬는 시간", time: "11:35-12:20" },
  { label: "점심 시간",    time: "12:20-13:20" },
  { label: "5교시+쉬는 시간", time: "13:20-14:15" },
  { label: "6교시+쉬는 시간", time: "14:15-15:10" },
  { label: "7교시+쉬는 시간", time: "15:10-16:05" },
  { label: "종례",          time: "16:05-16:15" },
  { label: "방과후",        time: "16:15-"     },
];

const Footer = styled.div`
  display: flex;
  justify-content: center;
`;

const CompleteButton = styled.button`
  width: 283px;
  height: 36px;
  background: ${props => props.disabled ? '#E5E5EA' : '#256EF4'};
  border: none;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;

const CompletText = styled.span`
  color: white;
  font-size: 17px;
  font-weight: 500;
  line-height: 25.5px;
`;

export default function MoleculePopupDropdown({ oneSelect, onConfirm, currentSelected }) {
  const [selectedOption, setSelectedOption] = useState(currentSelected || OPTIONS[1]);
  const [hasSelectionChanged, setHasSelectionChanged] = useState(false);

  const handleOptionSelect = (opt) => {
    setSelectedOption(opt);
    setHasSelectionChanged(true);
  };

  const handleConfirm = () => {
    if (hasSelectionChanged) {
      oneSelect(selectedOption);
      if (onConfirm) onConfirm();
    }
  };

  return (
    <List>
      <OptionGroup>
      {OPTIONS.map((opt) => (
        <Option 
          key={opt.label} 
          selected={selectedOption && selectedOption.label === opt.label}
          onClick={() => handleOptionSelect(opt)}
        >
          <Label>{opt.label}</Label>
          <Time>{opt.time}</Time>
        </Option>
      ))}
      </OptionGroup>
            <Footer>
        <CompleteButton 
          disabled={!hasSelectionChanged}
          onClick={hasSelectionChanged ? handleConfirm : undefined}
        >
          <CompletText>확인</CompletText>
        </CompleteButton>
      </Footer>
    </List>
  );
}

